'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabsMenu as TabsMenuUi, TabsMenuIcon, TabsMenuItem, TabsMenuLabel } from '@svenskaspelab/ui/react/tabs-menu';
import { usePathname, useSearchParams } from 'next/navigation';
import { isPathActive } from '../../schema/utils/entry.js';
import { TipsenLink } from '../TipsenLink/entry.js';
import { cn } from '../utils/entry.js';
/**
 * Component responsible to render menu items for tabs.
 *
 * @param root0 Component props
 * @param root0.tabItems Menu items to render in the menu
 * @param root0.routePath Optional routePath for the tabs menu, ex /enkelrader is needed to check if tab is active
 * @param root0.className Optional className to apply to the menu
 * @returns react component
 */
export default function TabsMenu({ tabItems, routePath, className }) {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const processEnvBasePath = process.env['NEXT_PUBLIC_BASE_PATH'] ?? '';
    const isActive = (item) => {
        if (item.selectedOnPaths &&
            isPathActive(pathname, item.selectedOnPaths, { basePath: `${processEnvBasePath}${routePath ?? ''}` })) {
            return true;
        }
        if (item.selectedOnQueries) {
            const queries = Object.entries(item.selectedOnQueries);
            for (const [key, activeParams] of queries) {
                if (activeParams.some((param) => param === searchParams.get(key))) {
                    return true;
                }
            }
        }
        return false;
    };
    return (_jsx(TabsMenuUi, { size: "sm", alignment: "left", className: cn(`bg-surface-standard text-container-neutral-foreground overflow-x-auto rounded-md pr-2 pl-2`, className), children: tabItems.map((item) => (_jsxs(TabsMenuItem, { className: "px-4", isActive: isActive(item), render: _jsx(TipsenLink, { className: "flex items-center justify-center", href: item.href, scroll: false, queriesToKeep: "ALL" }), children: [item.icon && _jsx(TabsMenuIcon, { children: item.icon }), _jsx(TabsMenuLabel, { children: item.label })] }, item.label))) }));
}
//# sourceMappingURL=TabsMenu.js.map